module.exports = __webpack_public_path__ + "static/work60-509ec7fe6e7e0377d738007166881dfd.jpg";